/**
 * Insctance of EffectCommand
 * @class EffectCommand
 */
import { calculateAspectRatioFit } from '../tools/ImageSize'
import { centerObject } from '../tools/WorksSpace'
export default class FullSizeCommand {
  /**
   * Constructor
   */
  constructor(target, direction = 'width') {
    this.label = 'SizeAdjust'
    this.target = target
    this.direction = direction
    this.oldWidth = 0
    this.oldHeight = 0
    this.element = null
  }

  execute() {
    this.element = this.target.canvas.getActiveObject()
    this.oldWidth = this.element.width * this.element.scaleX
    this.oldHeight = this.element.height * this.element.scaleY
    let size = null
    switch (this.direction) {
      case 'width':
        this.element.scaleToWidth(this.target.width, true)
        break
      case 'height':
        this.element.scaleToHeight(this.target.height, true)
        break
      default:
        this.element.scaleToWidth(this.target.width)
        this.element.scaleToHeight(this.target.height)
        break
    }
    this.centerize(this.target.canvas, this.element)
  }

  undo() {
    let size = null
    this.element.scaleToWidth(this.oldWidth, true)
    this.element.scaleToHeight(this.oldHeight, true)
    this.centerize(this.target.canvas, this.element)
  }

  centerize(canvas, active) {
    centerObject(canvas, active)
    this.element.setCoords()
  }
}



// WEBPACK FOOTER //
// ./src/model/pixel/command/FullSizeCommand.js